export default function Cancel() {
    return (
        <div style={{ backgroundColor: "black", textAlign: "center", borderRadius: 15 }}>
            <h1 style={{ color: "white" }}> Sorry to see you cancelled your payement</h1>
            <img src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925289/my_uploads/ys1hyadfswksnziajxst.gif" Alt="Sorry" style={{ width: 100, height: 130 }}></img>

        </div>
    )
}
